export default {
  club_name: 'Bäcken HC',
  club_name_short: 'backen',
  stadium_name: '',
  staging_url: 'https://backen.api.fangroup.io',
  prod_url: 'https://backen.api.fangroup.io',
  api: '/api',
  facebook: 'https://www.facebook.com/Backenhc/?locale=sv_SE',
  basename: '/backen',
  club_logo: '/assets/teams/backen.png',
  app_name: 'backen',
  websale_name: 'backen',
  ntb_team_id: 10041,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'backen',
  monolithEnabled: false,
};
